import { translate, localHref } from "../i18n";
import { useLocation } from "react-router-dom";
import { ArrowUpRight, ArrowRight, WhatsappLogo, FacebookLogo, InstagramLogo } from "@phosphor-icons/react";
import { NAV } from "../content/navigation";
export default function SiteFooter() {
  const {
    pathname
  } = useLocation();
  const homeAnchor = id => pathname === "/" ? "#" + id : "/#" + id;
  return <div className="ph site-footer-root">
      <footer className="ph-footer">
        <div className="ph-wrap">
          <div className="ph-footer-invitation">
            <div>
              <p className="ph-label">{translate("LOCARNO. CARTA, INCHIOSTRO, PERSONE.")}</p>
              <h2>{translate("Passa dalla carta.")}<br />
                <span>{translate("Alla realt\xE0.")}</span>
              </h2>
              <p>{translate("Passa da noi in Via Varenna, oppure scrivici.")}<br />{translate("Il tuo progetto comincia da una conversazione.")}</p>
            </div>
            <a href={localHref(homeAnchor("contatti"))} className="ph-footer-action">
              <span>{translate("Scrivici.")}<br />{translate("Cominciamo da qui.")}</span>
              <ArrowUpRight size={38} />
            </a>
          </div>
          <div className="ph-footer-top">
            <a href={localHref(homeAnchor("top"))}>
              <img src="/images/pedrazzini-print365-640.webp" width="2048" height="387" alt="Pedrazzini Print 365" />
            </a>
            <nav className="ph-social-links" aria-label={translate("Seguici sui social")}>
              <a href="https://www.facebook.com/profile.php?id=61582648204587" target="_blank" rel="noopener noreferrer"><span className="ph-social-icon"><FacebookLogo size={23} weight="fill" aria-hidden="true" /></span><span>Facebook</span></a>
              <a href="https://www.instagram.com/pedrazziniprint365/" target="_blank" rel="noopener noreferrer"><span className="ph-social-icon"><InstagramLogo size={23} aria-hidden="true" /></span><span>Instagram</span></a>
            </nav>
          </div>
          <div className="ph-footer-grid">
            <div className="ph-footer-address">
              <h3 className="ph-footer-heading">{translate("La nostra sede")}</h3>
              <p>Tipografia Pedrazzini Print 365 Sagl<br />Via Varenna 7 · 6600 Locarno</p>
            <a className="ph-whatsapp" href={localHref("https://wa.me/41764354080")} target="_blank" rel="noreferrer">
              <span>{translate("Contattaci su WhatsApp")}<small>+41 76 435 40 80</small>
              </span>
              <WhatsappLogo size={28} aria-hidden="true" />
            </a>

            </div>
            <div className="ph-footer-contact">
              <h3 className="ph-footer-heading">{translate("Parliamone")}</h3>
              <div className="ph-footer-contact-details">
              <a className="ph-footer-phone" href={localHref("tel:+41917517734")}>+41 91 751 77 34</a>
              <a href={localHref("mailto:info@pedrazziniprint365.ch")}>
                info@pedrazziniprint365.ch
              </a>
              </div>
            <div className="ph-affiliations">
              <a href={localHref("https://dpsuisse.ch/")} target="_blank" rel="noreferrer" aria-label="dp suisse">
                <AssociationLogo kind="dp" />
              </a>
              <a href={localHref("https://ticino.bni.swiss/")} target="_blank" rel="noreferrer" aria-label="BNI Ticino">
                <AssociationLogo kind="bni" />
              </a>
            </div>

            </div>
            <nav className="ph-footer-nav" aria-label={translate("Esplora il sito")}>
              <h3 className="ph-footer-heading">{translate("Esplora il sito")}</h3>
              <ul>{NAV.map(([id, label]) => <li key={id}><a href={localHref(id === "questo-mese" ? "/proposte/natale-2026/" : homeAnchor(id))}>
                  <ArrowRight size={16} aria-hidden="true" /><span>{label}</span>
                </a></li>)}</ul>
            </nav>
          </div>
          <div className="ph-footer-small">
            <p>
              © {new Date().getFullYear()}{translate(" Pedrazzini Print 365 \xB7 Gruppo Deco 365")}</p>
            <p>{translate("Video di repertorio:")}{" "}
              <a href={localHref("https://www.videezy.com/")} target="_blank" rel="noreferrer">
                Stock Footage by Videezy
              </a>
            </p>
          </div>
        </div>
      </footer>
  </div>;
}
function AssociationLogo({
  kind
}) {
  const dp = kind === "dp";
  const filterId = "association-white-" + kind;
  return <svg className={"ph-association-logo ph-association-" + kind} viewBox={dp ? "460 0 1269 434" : "0 0 200 77"} role="img" aria-label={dp ? "dpsuisse" : "BNI"}>
      <defs>
        <filter id={filterId} colorInterpolationFilters="sRGB">
          <feColorMatrix type="matrix" values="0 0 0 0 1  0 0 0 0 1  0 0 0 0 1  -1 -1 -1 0 3" />
          <feComposite in2="SourceGraphic" operator="in" />
        </filter>
      </defs>
      <image href={"/images/affiliations/" + (dp ? "dpsuisse" : "bni") + "-official.png"} x="0" y="0" width={dp ? 1729 : 200} height={dp ? 434 : 77} filter={"url(#" + filterId + ")"} />
    </svg>;
}
